import IPOItemComponent from "../../components/IPOItemComponent";
import { Col, Row } from "react-bootstrap";
import * as querySelectors from "../../../../selectors/query";
import _ from "lodash";
import EmptyItemView from "../../../../components/EmptyItemView";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import SubscribedIpoItemComponent from "../../components/SubscribedIpoItemComponent";

function SubscribedTab({data,onCancel,cancelLoading}) {
  const isLoading = querySelectors.getQueryIsLoading(data);
  const { data: ipoData } = querySelectors.getQueryData(data);
  return (
    <div className="pb-4">
      {!_.isEmpty(ipoData) ? (
        <Row className="row-gap-3">
          {_.map(ipoData, (item,index) => {
            return (
              <Col lg={6} xl={4} md={6} key={index}>
                <SubscribedIpoItemComponent item={item} cancelLoading={cancelLoading} onCancel={onCancel} />
              </Col>
            );
          })}
        </Row>
      ) : (
        <div className="position-relative">
          <EmptyItemView extraCss={{ height: "60vh" }} />
          <LoadingOverlay loading={isLoading}> </LoadingOverlay>
        </div>
      )}
    </div>
  );
}
export default SubscribedTab;